import { render, staticRenderFns } from "./ModalTodayLowestPrice.vue?vue&type=template&id=25554346&scoped=true&"
import script from "./ModalTodayLowestPrice.vue?vue&type=script&lang=ts&"
export * from "./ModalTodayLowestPrice.vue?vue&type=script&lang=ts&"
import style0 from "./ModalTodayLowestPrice.vue?vue&type=style&index=0&id=25554346&prod&lang=scss&scoped=true&"
import style1 from "./ModalTodayLowestPrice.vue?vue&type=style&index=1&id=25554346&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25554346",
  null
  
)

export default component.exports